import { Component } from '@angular/core';
import { ModalService } from 'src/app/project/components/modal/modal.service';

@Component({
    selector: 'pp-site-settings-plan-delete-modal',
    templateUrl: './site-settings-plan-delete-modal.component.html',
    styleUrl: './site-settings-plan-delete-modal.component.scss',
    standalone: false
})
export class SiteSettingsPlanDeleteModalComponent {
  public zIndex = 900;

  constructor(private modalService: ModalService) {}

  hideModal(cancel: boolean): void {
    this.modalService.hideModal(cancel);
  }
}
